// @flow
import { getCreator, postCreator, putCreator } from '../../http';
import environment from '../../environment';

export const endpoints = Object.freeze({
  GET_LOCATION: `${environment.apiUrl}/meta/location/search`,
  GET_FLIGHT: `${environment.apiUrl}/flight/:id`,
  PUT_FLIGHT: `${environment.apiUrl}/flight/:id`,
});

export const searchLocationApi = getCreator(fetch, endpoints.GET_LOCATION);
export const getFlightApi = getCreator(fetch, endpoints.GET_FLIGHT);
export const putFlightApi = putCreator(fetch, endpoints.PUT_FLIGHT);



// WEBPACK FOOTER //
// ./src/modules/edit-flight/api.js